import { AdminReviewEditor } from "../AdminReviewEditor";

export const NewAdminReview = () => <AdminReviewEditor />;
